/**
*
*   Wholesale Library
*       - A Wholesale connector with Shopify Tools
*
**/

import Translation from '@/components/translation';

//The Recaptcha Validation Class
const Recaptcha = {

	//The TOS Form message
	message: (
		<small className="recaptcha-note">
			<Translation t="Forms.Recaptcha.message" data={{
				privacy:    (chunks) => <a href="https://policies.google.com/privacy" target="_blank">{ chunks }</a>,
				terms:      (chunks) => <a href="https://policies.google.com/terms" target="_blank">{ chunks }</a>
			}} />
		</small>
	),

	//Validate a Request
	validate: async ( token , action = '' ) => {

		const response = await (
			await fetch(
				`https://recaptchaenterprise.googleapis.com/v1/projects/${ process.env.NEXT_RECAPTCHA_PROJECT_ID }/assessments?key=${ process.env.NEXT_SERVER_GOOGLE_API }`,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						event: {
							token:          token,
							siteKey:        process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
							expectedAction: action
						}
					})
				}
			)
		).json();

		console.log( response , process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY );

		if( !response.tokenProperties?.valid ) return false;
		return response.riskAnalysis?.score >= 0.5;

	}
};


//Output
export default Recaptcha;